import * as angular from "angular";
import * as _ from "lodash";
import {DataStoreConfig} from "./models/datastore-config.model";

export class LocalStoreService {

  $$localStores: any = {};

  constructor() {}

  getByKey<T>(dataStore: DataStoreConfig, key: string): T {
    const entity = this.getValue<T>(dataStore, key);
    if (!entity) {
      // this.$log.debug(`[LocalStoreService] "${dataStore.objectStoreName}" entity "${key}" not found in the local store`);
    }
    return entity;
  }

  save<T>(dataStore: DataStoreConfig, data: T[]): void {

    const storeName: string = dataStore.objectStoreName;
    const unique: string = dataStore.keyName;
    let store = _.get(this.$$localStores, storeName);

    if (_.isUndefined(store)) {
      _.set(this.$$localStores, storeName, {});
      store = _.get(this.$$localStores, storeName);
    }

    _.forEach(data, (entity) => {
      if (_.isObject(entity)) {
        _.set(store, entity[unique], entity);
      }
    });
  }

  getValue<T>(dataStore: DataStoreConfig, key: string): T {
    const storeName = dataStore.objectStoreName;
    const store = _.get(this.$$localStores, storeName);
    return _.get(store, key);
  }
}

angular
  .module('bringoz.admin.persistence')
  .service('localStoreService', LocalStoreService);
